// extracted by mini-css-extract-plugin
module.exports = {"globalNotifications":"globalNotifications__uO79z","preloader":"preloader__lK6zr"};